var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"btn",staticClass:"w-3 h-3 inline-block",attrs:{"data-clipboard-text":_vm.copyTxt}},[_c('img',{staticClass:"w-full h-full",attrs:{"src":_vm.copyIcon}})])}
var staticRenderFns = []

export { render, staticRenderFns }